import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fordable banner_setting" }
const _hoisted_2 = { class: "file_wrap" }
const _hoisted_3 = { for: "area_file" }
const _hoisted_4 = { class: "file_box_wrap" }
const _hoisted_5 = { for: "area_file_mobile" }
const _hoisted_6 = { class: "file_box_wrap" }
const _hoisted_7 = { class: "link_wrap" }
const _hoisted_8 = { class: "_flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "idx_span" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_BannerModal = _resolveComponent("BannerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _createElementVNode("input", {
                id: "area_file",
                type: "file",
                placeholder: "",
                accept: "image/*",
                multiple: "",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
              }, null, 32),
              _createElementVNode("div", _hoisted_4, _toDisplayString($setup.banner.file && $setup.banner.file.name ? $setup.banner.file.name : "PC 이미지를 추가해주세요."), 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "p_info" }, "PC 이미지 사이즈 2000*777", -1))
            ]),
            _createElementVNode("label", _hoisted_5, [
              _createElementVNode("input", {
                id: "area_file_mobile",
                type: "file",
                placeholder: "",
                accept: "image/*",
                multiple: "",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleFilesForMobile && $setup.handleFilesForMobile(...args)))
              }, null, 32),
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.banner.fileMobile && $setup.banner.fileMobile.name ? $setup.banner.fileMobile.name : "모바일 이미지를 추가해주세요."), 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", {
                class: "blue_btn",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, "파일첨부", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "p_info" }, "모바일 이미지 사이즈 500*466", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "링크를 입력해주세요",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.banner.link) = $event))
            }, null, 512), [
              [_vModelText, $setup.banner.link]
            ]),
            _createElementVNode("button", {
              class: "border_btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.addBanner && $setup.addBanner(...args)))
            }, "추가")
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.bannerList, (item, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.idx
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "move_up _sub",
                onClick: ($event: any) => ($setup.changeOrder(item, 0))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: "img/up_icon.png",
                  alt: ""
                }, null, -1)
              ]))], 8, _hoisted_9),
              _createElementVNode("button", {
                type: "button",
                class: "move_down _sub",
                onClick: ($event: any) => ($setup.changeOrder(item, 1))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: "img/down_icon.png",
                  alt: ""
                }, null, -1)
              ]))], 8, _hoisted_10)
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(item.idx), 1),
            (item.file)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "tb_img",
                  onClick: ($event: any) => ($setup.viewImage(item.file))
                }, [
                  _createElementVNode("img", {
                    style: {"max-width":"100%"},
                    src: item.file,
                    alt: ""
                  }, null, 8, _hoisted_13)
                ], 8, _hoisted_12))
              : _createCommentVNode("", true),
            (item.fileMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "tb_img",
                  onClick: ($event: any) => ($setup.viewImage(item.fileMobile))
                }, [
                  _createElementVNode("img", {
                    style: {"max-width":"100%"},
                    src: item.fileMobile,
                    alt: ""
                  }, null, 8, _hoisted_15)
                ], 8, _hoisted_14))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "입력된 링크가 없습니다.",
              "onUpdate:modelValue": ($event: any) => ((item.link) = $event),
              disabled: ""
            }, null, 8, _hoisted_16), [
              [_vModelText, item.link]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "border_btn",
              onClick: ($event: any) => ($setup.bannerModal(item.idx))
            }, "수정", 8, _hoisted_17),
            _createElementVNode("button", {
              type: "button",
              class: "table_btn _gray",
              onClick: ($event: any) => ($setup.isDelete(item.idx))
            }, "삭제", 8, _hoisted_18)
          ]))
        }), 128))
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowBannerModal)
      ? (_openBlock(), _createBlock(_component_BannerModal, {
          key: 1,
          bannerInfo: $setup.state.bannerInfo,
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.state.isShowBannerModal = false)),
          onSave: $setup.saveBanner
        }, null, 8, ["bannerInfo", "onSave"]))
      : _createCommentVNode("", true)
  ], 64))
}